import React, { Fragment } from "react";
import { styled } from "@mui/material/styles";
import { AnimatePresence } from "framer-motion";

import Navbar from "@common/Navbar";
import AnimateWrapper from "@common/animations/AnimateWrapper";
import Select from "@common/questions/Select";
import MultiSelect from "@common/questions/MultiSelect";
import ShortAnswer from "@common/questions/ShortAnswer";
import ImageCarousel from "../ImageCarousel";

const PREFIX = "ProductQuestions";

const classes = {
  imageDiv: `${PREFIX}-imageDiv`,
  questionsDiv: `${PREFIX}-questionsDiv`,
};

const StyledAnimateWrapper = styled(AnimateWrapper)(({ theme }) => ({
  display: "grid",
  placeItems: "center",
  gridTemplateColumns: "1fr 1fr",
  margin: "auto",
  maxWidth: 1280,
  padding: theme.spacing(5, 0),
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
    alignContent: "start",
    padding: 0,
    margin: "0 0 auto",
  },

  [`& .${classes.imageDiv}`]: {
    width: 550,
    height: 550,
    alignSelf: "flex-start",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "auto",
      marginBottom: theme.spacing(3),
    },
  },

  [`& .${classes.questionsDiv}`]: {
    width: "80%",
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
}));

const ProductQuestions = ({
  product,
  responses,
  setResponses,
  pageNum,
  setPageNum,
  selectedVariant,
}) => {
  const onBack = () => {
    if (pageNum <= 0 && product.use_variants) {
      setPageNum("SelectVariant");
    } else if (pageNum <= 0 && !product.use_variants) {
      setPageNum("ProductDescription");
    } else {
      setPageNum(pageNum - 1);
    }
  };

  return (
    <Fragment>
      <Navbar onBack={onBack} progressBarOffSet />
      <StyledAnimateWrapper key="ProductQuestions">
        <div className={classes.imageDiv}>
          <ImageCarousel
            images={
              selectedVariant
                ? new Array({
                    image: selectedVariant.product_image,
                    image_caption: selectedVariant.product_image_caption,
                  })
                : product && product.images
            }
          />
        </div>
        <AnimatePresence exitBeforeEnter>
          <div className={classes.questionsDiv}>
            {product &&
              product.product_questions.length > 0 &&
              product.product_questions.map((question, i) => {
                if (pageNum === i) {
                  if (question.question_type === "SE") {
                    return (
                      <AnimateWrapper key={i} motionKey={i}>
                        <Select
                          key={i}
                          question={question}
                          responses={responses}
                          setResponses={setResponses}
                          index={i + 1}
                          total={product.product_questions.length}
                          pageNum={pageNum}
                          setPageNum={setPageNum}
                        />
                      </AnimateWrapper>
                    );
                  } else if (question.question_type === "MS") {
                    return (
                      <AnimateWrapper key={i} motionKey={i}>
                        <MultiSelect
                          key={i}
                          question={question}
                          responses={responses}
                          setResponses={setResponses}
                          index={i + 1}
                          total={product.product_questions.length}
                          pageNum={pageNum}
                          setPageNum={setPageNum}
                        />
                      </AnimateWrapper>
                    );
                  } else if (question.question_type === "SA") {
                    return (
                      <AnimateWrapper key={i} motionKey={i}>
                        <ShortAnswer
                          key={i}
                          question={question}
                          responses={responses}
                          setResponses={setResponses}
                          index={i + 1}
                          total={product.product_questions.length}
                          pageNum={pageNum}
                          setPageNum={setPageNum}
                        />
                      </AnimateWrapper>
                    );
                  }
                }
              })}
          </div>
        </AnimatePresence>
      </StyledAnimateWrapper>
    </Fragment>
  );
};

export default ProductQuestions;
